import React, { Component, useState } from 'react'
import AutoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import Moment from 'Moment';
import { FormGroup } from './../../util/form-group/index';
import Modal from './../../util/modal/index';
import ModalDetalle from './../../util/modal/Detalle';
//import ReactSelect, { components } from 'react-select';

import {
    Sucursal_Lista, ConsultaFacturaFiscal, Factura_Global, Factura_Global_Por_Rango_Fecha, Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey, Sucursal_Fiscal_ListKey,
    Forma_De_Pago_List, ConsultaFacturaFiscalDetalle, Sucursal_ListaFiltro, FacturaFiscal_Imprimir
} from '../../request/rfc';

const FormatDateUniversal = 'YYYY/MM/DD';
const FormatDateCR = 'DD/MM/YYYY';
const DefaultOptionsucursal = { Suc_Id: "0", Nombre:"Seleccionar un sucursal"}
const DefaultOptionFormaPago = { Id: "0", Nombre: "Todas" };
const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

export default class Global extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            sucursal: 0,
            sucursales: [],
            fechaInicio: '',
            fechaFinal: '',
            selectedRow: {},
            serie: '',
            folio: '',
            folioUID: '',
            showModal: false,
            disabled: false,
            tipoFactura: '',
            anioFactura: 0,
            mesFactura: 0,
            formaPago: null,
            formasdePago: [],
            showModalDetalle: false,
            operacionDetalle: 0,
            fechaDetalle: '',
            faturaDetalle: [],
            FiltroBusqueda: '',
            fechaInicioAux: '',
            fechaFinAux: '',
            SelectedList: {},
        };
        localStorage.setItem("tipoFactura", '')
        AutoBind(this);
    }

    componentDidMount() {

        this.initTable([]);
        const $table = $(this.refs.tblFacturas);
        $table.on('click-row.bs.table', this.onClickTable);

        // get Sucursales 
        Sucursal_Lista()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    //const sucursal = Data[0].Suc_Id;
                    this.setState({ sucursales: [DefaultOptionsucursal, ...Data] });
                    //this.cargarFacturasGlobales(sucursal);
                }
            })
            .catch((err) => { console.log(err); });

        Forma_De_Pago_List()
            .then(({ data: Response }) => {
                const { Message, Data } = Response
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ formasdePago: [DefaultOptionFormaPago, ...Data] });
                }
            })
            .catch((err) => { console.log(err); });
    }

    componentWillUnmount() {
        // validar lo de las fechas, para destruir el componente
        $(document.getElementById('fechaInicio')).datepicker('destroy');
        $(document.getElementById('fechaFinal')).datepicker('destroy');
    }

    onChange(e) {
        const { name, value } = e.target;
        if (name === 'sucursal') {
            this.loadFiltros(value);
        }
        if (name === 'formasdePago') {
            this.setState({ formaPago: value });
        }
        this.setState({ [name]: value });
        if (name === 'FiltroBusqueda') {
            this.Sucursal_ListaFiltro(value);
        }
    }

    Sucursal_ListaFiltro(pNombre) {
        Sucursal_ListaFiltro(pNombre)
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ sucursales: [DefaultOptionsucursal, ...Data] });

                }
            }).catch((err) => { console.log('Error:' + err); });
    }

    loadFiltros(suc_Id) {
        Sucursal_Fiscal_ListKey(suc_Id)
            .then(({ data: Response }) => {
                const { Message, Data: fiscal } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({
                        tipoFactura: fiscal.Fiscal_Tipo_Global_id,
                        anioFactura: '0',
                        mesFactura: '0'
                    });
                    this.filtrosFactura();
                    localStorage.setItem("tipoFactura", fiscal.Fiscal_Tipo_Global_id)
                    if (fiscal.Fiscal_Tipo_Global_id === 'D' || fiscal.Fiscal_Tipo_Global_id === 'R') {
                        this.setState({
                            fechaInicio: Moment().subtract(7, 'days').format('DD/MM/YYYY'),
                            fechaFinal: Moment().format('DD/MM/YYYY'),

                            fechaInicioAux: Moment().subtract(7, 'days').format('L'),
                            fechaFinAux: Moment().format('L')
                        })
                        this.onchangeFechas();
                    } else {
                        this.setState({
                            fechaInicio: '',
                            fechaFinal: '',
                            fechaInicioAux,
                            fechaFinAux,
                            anioFactura: 0,
                            mesFactura :0
                        })
                    }
                }
            })
            .catch((err) => { console.log(err); });

    }

    Forma_De_Pago_List() {
        Forma_De_Pago_List.then(({ data: Response }) => {
            const { Message, Data } = Response
            if (Message !== '') {
                alert(Message);
            } else {
                this.setState({ formasdePago: Data });
            }
        })
        .catch((err) => { console.log(err); });
    }

    cargarFacturasGlobales(sucursal) {
        this.setState({ tipoFactura: localStorage.getItem("tipoFactura") })
        const { fechaInicio, fechaFinal, tipoFactura, anioFactura, mesFactura, fechaInicioAux, fechaFinAux, formaPago } = this.state;
        ConsultaFacturaFiscal({ pSucursal: sucursal, pFechaInicio: (fechaInicioAux === '' ? Moment().format('L') : fechaInicioAux), pFechaFinal: (fechaFinAux === '' ? Moment().format('L') : fechaFinAux), pTipoFactura: tipoFactura, pAnioFactura: anioFactura, pMesFactura: mesFactura, pFormaPago: formaPago })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    if (Data != null && Data.length > 0) { 
                        const data = Data.map(item => Object.assign({}, item, { Fecha_Apertura: Moment(item.Fecha_Apertura).format(FormatDateCR), SelectedList: data })); 
                        this.setState({
                            SelectedList: data
                        });
                        this.initTable([]);
                        this.loadTable(data);
                    } else {
                        this.initTable([]);
                        this.loadTable(data);
                    }
                }
            })
            .catch((err) => { console.log(err); });
    }

    cargarFacturasGlobalesDetalle(sucursal, operation, Fiscal_NumeroFacturaGlobal, pfechaDetalle, operationFinal) {

        this.setState({ tipoFactura: localStorage.getItem("tipoFactura") })
        const { fechaInicio, fechaFinal, tipoFactura, anioFactura, mesFactura } = this.state;
         
        ConsultaFacturaFiscalDetalle({ pSucursal: sucursal, pTipoFactura: tipoFactura, pOperation: operation, pFiscal_NumeroFacturaGlobal: Fiscal_NumeroFacturaGlobal, pOperationFinal: operationFinal })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    if (Data != null && Data.length > 0) {
                        const data = Data.map(item => Object.assign({}, item, { Fecha_Apertura: Moment(item.Fecha_Apertura).format(FormatDateCR) }));
                        this.setState({
                            showModalDetalle: true, faturaDetalle: data, disabled: false, operacionDetalle: operation, fechaDetalle: pfechaDetalle
                        });
                    } else {
                        this.setState({ disabled: false });
                        alert('No se encontraron datos.');
                    }
                    
                }
            })
            .catch((err) => { console.log(err); });
    }

    initTable(data) {
        const $table = $(this.refs.tblFacturas); 
        let _columnas = [];
        let _returns = '';

        if (this.state.tipoFactura === 'D') {
            _columnas = [{
                title: '# Operación',
                field: 'Operacion_id',
                sortable: true
            }, {
                title: 'Fecha Apertura',
                field: 'Fecha_Apertura'
            }, {
                title: '# Factura Fiscal',
                field: 'Fiscal_NumeroFacturaGlobal',
                sortable: true
                }];

        }
        else if (this.state.tipoFactura === 'S') {
            _columnas = [{
                title: '# Semana',
                field: 'Semana',
                sortable: true
            }, {
                title: 'Operacion Inicial',
                field: 'Operacion_Inicial'
            }, {
                title: 'Operación Final',
                field: 'Operacion_Final',
                sortable: true
                }, {
                    title: 'Factura Fiscal',
                field: 'Fiscal_NumeroFacturaGlobal',
                    sortable: true
                }];

        }
        else if (this.state.tipoFactura === 'M') {
            _columnas = [{
                title: '# Mes',
                field: 'Mes',
                sortable: true
            }, {
                title: 'Operacion Inicial',
                field: 'Operacion_Inicial'
            }, {
                title: 'Operación Final',
                field: 'Operacion_Final',
                sortable: true
            }, {
                title: 'Factura Fiscal',
                field: 'Fiscal_NumeroFacturaGlobal',
                sortable: true
                }];
        } else if (this.state.tipoFactura === 'R') {
            _columnas = [
                {
                    title: 'Marcar',
                    formatter: function (value, row, index) {
                        return '<input type="checkbox" name="Checkbox" id="' + row.Documento + '" value="false" />'
                    }
                }, {
                    title: 'Contado',
                    field: 'TipoDoc_Id',
                    sortable: true
                }, {
                    title: 'Ticket',
                    field: 'Factura_Id',
                    sortable: true
                }, {
                    title: 'Caja',
                    field: 'Caja_Id',
                    sortable: true
                }, {
                    title: '# Operación',
                    field: 'Operacion_id',
                    sortable: true
                }, {
                    title: 'Fecha Venta',
                    field: 'Fecha_Apertura'
                }, {
                    title: '# Factura Fiscal',
                    field: 'Fiscal_NumeroFacturaGlobal',
                    sortable: true
                }];
        }
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) {

                if (row.Semana === 0 && row.Mes === 0) {
                    return { 'data-id': row.Operacion_id, 'data-genera': row.Fiscal_NumeroFacturaGlobal === '' }
                }
                else {
                    return { 'data-id': row.Operacion_Inicial,'data-genera': row.Fiscal_NumeroFacturaGlobal === '' }
                }
                
               
            },
            columns: _columnas
        });
    }

    loadTable(data) {
        const $table = $(this.refs.tblFacturas);
        $table.bootstrapTable('load', data || []);
    }

    onSearch() {
        const { sucursal } = this.state;
        this.cargarFacturasGlobales(sucursal);
    }

    onDetalle() {
        this.setState({ disabled: true });
        const { sucursal, selectedRow } = this.state; 
        this.setState({
            showModal: true, serie: Data.Serie, folio: Data.NumeroFactura,
            folioUID: Data.UUID, modalSucursal: sucursal, disabled: false
        });
    }

    onAplicar() {
        this.setState({ disabled: true });
        const { sucursal, selectedRow, anioFactura, mesFactura, fechaFinal, tipoFactura, formaPago } = this.state;
        if (tipoFactura == 'R') {
            const Aplicados = this.state.SelectedList.filter(item => item.Aplicar == true);
            if (Aplicados.length == 0) {
                alert('No hay datos seleccionados.');
                this.setState({ disabled: false });
            } else {
                Factura_Global_Por_Rango_Fecha({ pDatos: Aplicados })
                    .then(({ data: Response }) => {
                        const { Message, Data } = Response;
                        if (Message !== '') {
                            alert(Message);
                            this.setState({ disabled: false });
                        } else {
                            this.cargarFacturasGlobales(sucursal);
                            this.setState({
                                showModal: true, serie: Data.Serie, folio: Data.NumeroFactura,
                                folioUID: Data.UUID, modalSucursal: Data.Suc_Id, disabled: false
                            });
                        }
                    })
                    .catch((err) => { console.log(err); this.setState({ disabled: false }); });
            }
            console.log('Aplicados', Aplicados)
            

        } else { 
            if (selectedRow.Fiscal_NumeroFacturaGlobal === '') {
                let _formasPago = '';
                if (formaPago === null) {
                    _formasPago = '';
                }
                else {
                    for (const f of formaPago) {
                        _formasPago += f.value + ',';
                    }
                    _formasPago = _formasPago.substring(0, _formasPago.length - 1)
                }
                let _fecha = selectedRow.Fecha_Apertura;
                let operation = selectedRow.Operacion_id;

                if (selectedRow.Semana > 0 || selectedRow.Mes > 0) {
                    operation = selectedRow.Operacion_Inicial + ',' + selectedRow.Operacion_Final;
                }
                if (tipoFactura === 'S' || tipoFactura === 'M') {
                    _fecha = Moment(new Date(anioFactura, mesFactura, 1)).format('L');
                }

                Factura_Global({ pSucursal: sucursal, pOperacion: operation, pFecha: _fecha, pFormaPago: _formasPago})
                    .then(({ data: Response }) => {
                        const { Message, Data } = Response;
                        if (Message !== '') {
                            alert(Message);
                            this.setState({ disabled: false });
                        } else {
                            this.cargarFacturasGlobales(sucursal);
                            this.setState({
                                showModal: true, serie: Data.Serie, folio: Data.NumeroFactura,
                                folioUID: Data.UUID, modalSucursal: Data.Suc_Id, disabled: false
                            });
                        }
                    })
                    .catch((err) => { console.log(err); this.setState({ disabled: false }); });
            } else {
                this.setState({ disabled: false });
                alert('La operación ya fue facturada');
            } 
        }
    }
    
    onClickTable(row, $element, field) {
        const selectedRow = document.querySelector('tr.table-info');
        if (!!selectedRow)
            selectedRow.classList.remove('table-info');
        if ($element.Operacion_id > 0) {
            document.querySelector(`tr[data-id="${$element.Operacion_id}"]`).classList.add('table-info');
        }
        else {
            
            document.querySelector(`tr[data-id="${$element.Operacion_Inicial}"]`).classList.add('table-info');
        }
       
        this.setState({ selectedRow: $element });

        
        for (let i = 0; i < this.state.SelectedList.length; i++) {
            if ($element.Factura_Id == this.state.SelectedList[i].Factura_Id && $element.Caja_Id == this.state.SelectedList[i].Caja_Id) {
                this.state.SelectedList[i].Aplicar = field.prevObject[0].firstChild.checked;
            }

        } 
    }

    onChangeSelectFormaPago = (selected) => {
        this.setState({ formaPago: selected });
    };

    onXML() {
        const { modalSucursal, folio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: modalSucursal, pFolio: folio })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    reimpriPDF() {  
        FacturaFiscal_Imprimir({ pEmp_id: 1, pSuc_id: this.state.sucursal, pNumero: this.state.selectedRow.Fiscal_NumeroFacturaGlobal })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;  
                console.log(Data && Data.length ? Data.length : 0);
                if (Message) {
                    alert(Message);
                    return;
                }
                if (Data && Data.Table && Data.Table.length > 0) {
                    this.setState({
                        showModal: true,
                        serie: Data.Table[0].Fiscal_Serie,
                        folio: Data.Table[0].Fiscal_NumeroFactura,
                        folioUID: Data.Table[0].Fiscal_UUID,
                        modalSucursal: Data.Table[0].Suc_Id,
                        disabled: false
                    });
                } else {
                    alert("No hay datos.");
                }
            })
            .catch((err) => { console.log(err); });
    }

    onPDF() {
        const { modalSucursal, folioUID } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: modalSucursal, pFolio: folioUID })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', Data.Nombre);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onCloseModal() {
        this.setState({ showModal: false });
    }

    onCloseModalDetalle() {
        this.setState({ showModalDetalle: false });
    }

    onchangeFechas() {
     
        const fechaInicio = $(document.getElementById('fechaInicio'));
        const fechaFinal = $(document.getElementById('fechaFinal'));
        const dateOptions = { format: 'dd/mm/yyyy', autoclose: true, language: 'es' };

        fechaInicio.datepicker(dateOptions).on('changeDate', (e) => {
                fechaFinal.datepicker('setStartDate', e.date);
            this.setState({ fechaInicio: Moment(e.date).format('DD/MM/YYYY') });

            this.setState({ fechaInicioAux: Moment(e.date).format('L') });
        });

        fechaFinal.datepicker(dateOptions).on('changeDate', (e) => {
                fechaInicio.datepicker('setEndDate', e.date);
            this.setState({ fechaFinal: Moment(e.date).format('DD/MM/YYYY') });

            this.setState({ fechaFinAux: Moment(e.date).format('L') });
        }); 

        fechaFinal.datepicker('setStartDate', Moment(new Date(this.state.fechaInicio)).format('DD/MM/YYYY'));
        fechaInicio.datepicker('setEndDate', Moment(new Date(this.state.fechaFinal)).format('DD/MM/YYYY'));

    }

    onChangeData(e)
    {
        const { name, value } = e.target

        if (name === 'anioFactura') {
            this.setState({ anioFactura: value })
        }
        if (name === 'mesFactura') {
            this.setState({ mesFactura: value })
        }     
    }

    filtrosFactura(OptionsPago) {

        if (this.state.tipoFactura === '')
        {
            return null;
        }
   
        switch (this.state.tipoFactura) {
            case "D":

                return (
                    <div className="form-inline col-md-12" id="fechas">
                        <div className="form-group col-md-3">
                            <label>Periodicidad: Por Día</label>
                        </div>
                        <div className="form-group col-md-3">
                            <label>Fecha Inicial:</label>
                            <input type="text" name="fechaInicio" id="fechaInicio" className="form-control datepicker" value={this.state.fechaInicio} onChange={this.onchangeFechas} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Fecha Final:</label>
                            <input type="text" name="fechaFinal" id="fechaFinal" className="form-control" value={this.state.fechaFinal} onChange={this.onchangeFechas} readOnly  />
                        </div>
                    </div>
                );
            case "S":
                return (

                    <div className="form-inline col-md-12" id="mesAnio">
                        <div className="form-group col-md-3">
                            <label>Periodicidad: Por Semana</label>
                        </div>
                        <div className="form-group col-md-3">
                            <label>Año:</label>
                            <input type="number" name="anioFactura" id="anioFactura" className="form-control" min="0" value={this.state.anioFactura} onChange={this.onChangeData} onClick={this.removeClass} autoComplete="off" />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Mes:</label>
                            <input type="number" name="mesFactura" id="mesFactura" className="form-control" min="0" value={this.state.mesFactura} onChange={this.onChangeData} onClick={this.removeClass} autoComplete="off" />
                        </div>
                    </div>

                );
            case "M":
                return (
                    <div className="form-inline col-md-12">
                        <div className="form-group col-md-3">
                            <label>Periodicidad: Por Mes</label>
                        </div>
                        <div className="form-group col-md-3">
                            <label>Año:</label>
                            <input type="number" className="form-control" name="anioFactura" className="form-control" min="0" value={this.state.anioFactura} onChange={this.onChange} onClick={this.removeClass} autoComplete="off" />
                        </div>
                    </div>

                )
            case "R":

                return (

                    <div className="form-inline col-md-12" id="fechas">
                        <div className="form-group col-md-3">
                            <label>Periodicidad: Rango de Fecha:</label>
                        </div>
                        <div className="form-group col-md-3">
                            <label>Fecha Inicial:</label>
                            <input type="text" name="fechaInicio" id="fechaInicio" className="form-control datepicker" value={this.state.fechaInicio} onChange={this.onchangeFechas} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Fecha Final:</label>
                            <input type="text" name="fechaFinal" id="fechaFinal" className="form-control" value={this.state.fechaFinal} onChange={this.onchangeFechas} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Forma Pago:</label>
                            <select name="formaPago" className="form-control" value={this.state.formaPago} onChange={this.onChange} readOnly >
                                {OptionsPago}
                            </select>
                        </div>
                    </div>
                );
        }


    }

    removeClass() {
        
        const div = document.getElementsByClassName('datepicker datepicker-dropdown dropdown-menu datepicker-orient-left datepicker-orient-top');
        if (div[0] !== undefined) {
            div[0].remove();
    }         
    }

    render() {

        const { baseUrl, sucursal, sucursales, serie, folio, showModal, disabled, tipoFactura, fechaInicio, fechaFinal, formaPago, formasdePago, showModalDetalle, fechaDetalle, operacionDetalle, faturaDetalle, FiltroBusqueda } = this.state;
        const Options = sucursales.map(item => <option key={item.Suc_Id} value={item.Suc_Id}>{item.Nombre}</option>)

        const OptionsPago = formasdePago.map(item => <option key={item.Id} value={item.Id}>{item.Nombre}</option>)
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
;

        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-12">
                            <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                <i className="fas fa-angle-double-left"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-3">
                            <label>Filtro Búsqueda:</label>
                            <input type="text" className="form-control" name="FiltroBusqueda" value={FiltroBusqueda} placeholder=""
                                onChange={this.onChange} />
                        </div>
                        <div className="form-group col-md-6">
                            <label>Sucursales:</label>
                            <select name="sucursal" className="form-control" value={sucursal} onChange={this.onChange} disabled={disabled}>
                                {Options}
                            </select>
                        </div>

                    </div>
                    <div className="row" id="formaPago" style={{ display: "" ? "none" : "none" }}>
                        <div className="form-group col-md-11">
                            <label>Forma de Pago:</label>
                            {/*<ReactSelect*/}
                            {/*    options={formasdePago}*/}
                            {/*    isMulti*/}
                            {/*    closeMenuOnSelect={false}*/}
                            {/*    hideSelectedOptions={false}*/}
                            {/*    components={{*/}
                            {/*        Option*/}
                            {/*    }}*/}
                            {/*    onChange={this.onChangeSelectFormaPago}*/}
                            {/*    allowSelectAll={true}*/}
                            {/*    value={this.state.formaPago}*/}
                            {/*    placeholder= "Formas de pago"*/}
                            {/*/>*/}
                            {/*<Select name="formaPago" className="form-control" value={formaPago} onChange={this.onChange} disabled={disabled} option={formasdePago}></Select>*/}
                        </div>
                    </div>
                    <div className="row">
                        {
                            this.filtrosFactura(OptionsPago)
                        }

                        
                        <div className="col-md-1">
                            <button type="button" className="btn btn-custom-theme margin-top-30" disabled={disabled} onClick={this.onSearch}>
                                <i className="fas fa-search"></i>
                            </button>
                        </div>


                    </div>

                    <div className="row">
                        <div id="toolbar">
                            <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onAplicar}>
                                <i className={disabled ? 'fas fa-spinner fa-spin' : 'fas fa-clipboard-check'}></i>
                            </button>
                            <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.reimpriPDF}>
                                <i className={disabled ? 'fas fa-spinner fa-spin' : 'fas fa-clipboard-list'}></i>
                            </button>
                        </div>

                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12">
                            <table ref="tblFacturas"></table>
                        </div>
                    </div>
                </div>
                
                
                <Modal show={showModal}
                    serie={serie}
                    folio={folio}
                    onXML={this.onXML}
                    onPDF={this.onPDF}
                    onCloseModal={this.onCloseModal}
                />
                
                
                <ModalDetalle show={showModalDetalle}
                    operacion={operacionDetalle}
                    fecha={fechaDetalle}
                    data={faturaDetalle}
                    onCloseModal={this.onCloseModalDetalle}
                />
                
            </div>

            
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/global/index.jsx